import { I18nManager } from 'react-native';
import { isWeb } from './detectDevice';
export const isRTL = isWeb ? I18nManager.getConstants().isRTL : I18nManager.isRTL;

export const getIsRTLString = (str) => {
  const hebrewRegExp = new RegExp(/^[\u0590-\u05fe]+/i);

  return hebrewRegExp.test(str);
};
